// Copyright (c) 2023 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import PinPlateForm from './duplicate-pin-plate-form';

class DuplicatePinPlateRequest extends Component {

    componentWillMount() {

        this.props.actions.readPinPlateRequest(this.props.queryParams.pinPlateId);

    }

    componentWillUnmount() {

        this.props.actions.resetDuplicatePinPlate();

    }

    render() {

        return (
            <section className='new-registration'>

                <PinPlateForm/>
            </section>
        );

    }

}

DuplicatePinPlateRequest.displayName = 'DuplicatePinPlateRequest';
DuplicatePinPlateRequest.propTypes = {
    actions: PropTypes.object.isRequired,
    queryParams: PropTypes.object.isRequired
};

export default DuplicatePinPlateRequest;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/duplicate-pin-plate-request.js